import { Dialog, DialogContent, Box, Typography, DialogActions, FormHelperText, MenuItem, Select, Button } from '@mui/material';
import { setSuccessfullModifyDialog } from '../../../redux/successfullModifyDialogSlice';
import { setMachineDetailsData } from '../../../redux/machineDetailsDataSlice';
import { CustomErrorLogger } from '../../../utils/CustomErrorLogger';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import Iconify from '../../Iconify';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import '../../../css/machines/modifierStatut.css';

export const ModifierStatut = ({ modifyStatut, setModifyStatut }) => {

    const { t } = useTranslation();
    const { id } = useParams();
    const dispatch = useDispatch();
    const machineDetailsData = useSelector((state) => state.MachineDetailsData);

    const formik = useFormik({
        initialValues: {
            status: machineDetailsData?.status,
        },
        validationSchema: Yup.object().shape({
            status: Yup.string().required(),
        }),
        onSubmit: async (values) => {
            try {
                const data = {
                    status: values.status,
                };
                const response = await axios.patch(`machine/machine_status/${id}`, data);
                if (response.status === 200 || response.status === 201) {
                    dispatch(setSuccessfullModifyDialog({ open: true, type: 'Modifier le statut de contrôle' }));
                    dispatch(setMachineDetailsData({ ...machineDetailsData, status: response.data.status }));
                    setModifyStatut(false);
                }
            } catch (error) {
                console.error('Error updating machine status:', error);
                CustomErrorLogger(error, 'Error updating machine status in ModifierStatut');
            }
        },
    });

    const { handleSubmit, values, handleBlur, touched, errors, handleChange } = formik;

    return (
        <Dialog open={modifyStatut} fullWidth>
            <Box onClick={() => setModifyStatut(false)} className='modifierStatut_icon_text'>
                <Typography className='modifierStatut_title'>{t('Modifier le statut de contrôle')}</Typography>
                <Iconify icon={"material-symbols:close"} className='modifierStatut_close_icon' />
            </Box>
            <form onSubmit={handleSubmit}>
                <DialogContent className='modifierStatut_dialog_content'>
                    {values.errMsg && <Typography className='modifierStatut_attention_text'>{values.errMsg}</Typography>}

                    <Box className="modifierStatutDateBox">
                        <FormHelperText id="outlined-weight-helper-text" className="modifierStatutInputTitle">{t('Statut contrôle')}</FormHelperText>
                        <Select
                            className={`modifierStatut_select_metier ${values.status ? 'filledField' : ''}`}
                            value={values.status}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="status"
                            error={touched.status && Boolean(errors.status)}
                        >
                            <MenuItem className='modifierStatut_select_metier_item' value='Valide'>{t('Valide')}</MenuItem>
                            <MenuItem className='modifierStatut_select_metier_item' value='AvecReparation'>{t('Avec réparation')}</MenuItem>
                            <MenuItem className='modifierStatut_select_metier_item' value='NonConforme'>{t('Non conforme')}</MenuItem>
                        </Select>
                    </Box>
                </DialogContent>
                <DialogActions className='modifierStatut_dialog_actions'>
                    <Button className='modifierStatut_button_annuler' onClick={() => setModifyStatut(false)}>{t('Annuler')}</Button>
                    <Button className='modifierStatut_button_valider' variant="contained" type="submit">{t('Valider')}</Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};
